import {Record, List} from 'immutable';
import moment from 'moment-timezone';

const FoodItemModel = Record({
    id: String(),
    institutionId: String(),
    title: String(),
    lastUsed: String(),
    createdAt: Object(), // moment
    unit: null,
});

const foodItemFromAPI = data => {
    return new FoodItemModel({
        ...data,
        createdAt: moment(data.createdAt),
    });
};

export const FoodItem = {
    record: FoodItemModel,
    fromAPI: foodItemFromAPI,
};

const MealRegistrationChangeLogItem = Record({
    name: String(),
    loginId: String(),
});

const MealRegistrationModel = Record({
    id: String(),
    childId: String(),
    mealTypeId: String(),
    mealItems: List(),
    createdAt: Object(), // moment
    lastUpdatedAt: Object(),
    createdBy: new MealRegistrationChangeLogItem(),
    lastUpdatedBy: new MealRegistrationChangeLogItem(),
});

const MealItemModel = Record({
    id: String(),
    foodItemId: String(),
    mealRegistrationId: String(),
    amount: Number(),
    unitAmount: null,
    unit: null,
});

const mealRegistrationFromAPI = data => {
    return new MealRegistrationModel({
        ...data,
        createdAt: moment.tz(data.createdAt, data.timeZone),
        lastUpdatedAt: moment(data.lastUpdatedAt),
        createdBy: new MealRegistrationChangeLogItem(data.createdBy),
        lastUpdatedBy: new MealRegistrationChangeLogItem(data.lastUpdatedBy),
        mealItems: List(data.mealItems.map(mealItem => new MealItemModel(mealItem))),
    });
};

export const MealRegistration = {
    record: MealRegistrationModel,
    fromAPI: mealRegistrationFromAPI,
};

export default {
    FoodItem,
    MealRegistration,
};
